/**
 * Email chips input - allows adding up to 5 emails as removable chips
 */
(function () {
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(value) {
    return value && EMAIL_REGEX.test(value.trim());
  }

  window.initEmailChips = function (container, prepopulate) {
    const listEl = container.querySelector('[data-email-chips-list]');
    const inputEl = container.querySelector('[data-email-chips-input]');
    const hiddenEl = container.querySelector('[data-email-chips-hidden]');
    const errorEl = container.querySelector('[data-email-chips-error]');
    const maxEmails = parseInt(container.dataset.maxEmails || '5', 10);

    let emails = [];

    function updateHiddenInput() {
      hiddenEl.value = emails.join(',');
    }

    function showLimitError() {
      if (errorEl) {
        errorEl.closest('.rs-input__content').classList.add('rs-error');
      }
    }

    function hideLimitError() {
      if (errorEl) {
        errorEl.closest('.rs-input__content').classList.remove('rs-error');
      }
    }

    function createChip(email) {
      const chip = document.createElement('span');
      chip.className = 'rs-email-chips__chip';
      chip.dataset.email = email;
      chip.innerHTML = `
        <span>${escapeHtml(email)}</span>
        <button type="button" class="rs-email-chips__chip-remove" aria-label="Remove ${escapeHtml(email)}">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      `;
      chip.querySelector('.rs-email-chips__chip-remove').addEventListener('click', () => removeEmail(email));
      return chip;
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function addEmail(email) {
      const trimmed = email.trim().toLowerCase();
      if (!trimmed || !isValidEmail(trimmed)) {
        hideLimitError();
        console.log('Invalid email');
        return false;
      }
      if (emails.includes(trimmed)) {
        console.log('Email already exists');
        hideLimitError();
        return false;
      }
      if (emails.length >= maxEmails) {
        console.log('Email limit reached');
        showLimitError();
        return false;
      }

      emails.push(trimmed);
      listEl.appendChild(createChip(trimmed));
      updateHiddenInput();
      inputEl.value = '';
      hideLimitError();
      return true;
    }

    function removeEmail(email) {
      emails = emails.filter((e) => e !== email);
      const chip = listEl.querySelector(`[data-email="${escapeHtml(email)}"]`);
      if (chip) chip.remove();
      updateHiddenInput();
      hideLimitError();
    }

    function handleInputKeydown(e) {
      if (e.key === 'Enter' || e.key === ',') {
        e.preventDefault();
        const value = e.key === ',' ? inputEl.value.replace(',', '') : inputEl.value;
        addEmail(value);
      }
      if (e.key === 'Backspace' && !inputEl.value && emails.length > 0) {
        const lastEmail = emails[emails.length - 1];
        removeEmail(lastEmail);
      }
    }

    function handleInputBlur() {
      const value = inputEl.value.trim();
      if (value) addEmail(value);
    }

    function handleInputPaste(e) {
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      if (pastedText && (pastedText.includes(',') || pastedText.includes(' ') || pastedText.includes('\n'))) {
        e.preventDefault();
        const parts = pastedText.split(/[,\s\n]+/).filter(Boolean);
        parts.forEach((part) => addEmail(part));
      }
    }

    inputEl.addEventListener('keydown', handleInputKeydown);
    inputEl.addEventListener('blur', handleInputBlur);
    inputEl.addEventListener('paste', handleInputPaste);

    if (prepopulate) {
      const emailValues = hiddenEl.value.split(',').filter(Boolean);
      emailValues.forEach((email) => addEmail(email));
    }
  }

  const initialized = new WeakSet();

  function init() {
    document.querySelectorAll('[data-email-chips]').forEach((container) => {
      if (!initialized.has(container)) {
        initialized.add(container);
        window.initEmailChips(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when section loads in theme editor
  document.addEventListener('shopify:section:load', init);
})();
